module.exports = __webpack_public_path__ + "img/iconjudge.17a70a9e.svg";